import { EntityImageManager } from '@/components/entity-image-manager';
import { useSubscription } from '@/hooks/useSubscription';
import type { Organization, ProcessedImage } from '@/lib/types';

interface ImageManagerProps {
  onUpdate: (updates: { images?: ProcessedImage[], pendingFiles?: File[], primaryImageId?: string | null }) => void;
  organization: Organization;
  pendingFiles?: File[];
  isProcessing?: boolean;
  visualDescription?: string;
  onVisualDescriptionChange?: (value: string) => void;
  disableDeletion?: boolean;
}

export function ImageManager({
  onUpdate,
  organization,
  pendingFiles,
  isProcessing = false,
  visualDescription,
  onVisualDescriptionChange,
  disableDeletion
}: ImageManagerProps) {
  const { hasFeature, isTokenDepleted } = useSubscription();
  const canCreateAIImages = hasFeature('can_create_ai_images');

  return (
    <EntityImageManager
      type="organizations"
      images={organization.images || []}
      primaryImageId={organization.primaryImageId ?? null}
      onUpdate={onUpdate}
      pendingFiles={pendingFiles}
      isProcessing={isProcessing}
      entityId={organization.id}
      canCreateAIImages={canCreateAIImages}
      isTokenDepleted={isTokenDepleted}
      visualDescription={visualDescription}
      onVisualDescriptionChange={onVisualDescriptionChange}
      disableDeletion={disableDeletion}
    />
  );
}
